/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Preview_LedeInputs */

const en_platform_preview_lede = /** @type {(inputs: Platform_Preview_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set your hours once. Clients pick from what is genuinely free, and confirmations and reminders go out without you lifting a finger.`)
};

const pl_platform_preview_lede = /** @type {(inputs: Platform_Preview_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ustawiasz godziny raz. Podopieczni wybierają z tego, co naprawdę wolne, a potwierdzenia i przypomnienia wychodzą bez Twojego udziału.`)
};

/**
* | output |
* | --- |
* | "Set your hours once. Clients pick from what is genuinely free, and confirmations and reminders go out without you lifting a finger." |
*
* @param {Platform_Preview_LedeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_preview_lede = /** @type {((inputs?: Platform_Preview_LedeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Preview_LedeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_preview_lede(inputs)
	return en_platform_preview_lede(inputs)
});